module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec01_img_02-f2723b9611db32ddfc766b62520d20c1.png";